import axios from "axios";

function getSubstitutionProposals(routeParams = {}, data = {}, urlParams = {}) {
    return axios.get('api/v1/substitution-proposals', { params: urlParams });
}

function updateSubstitutionProposalStatus({id}, data) {
    return axios.post(`api/v1/substitution-proposals/${id}/update-status`, data);
}

function getSubstitutionProposalByHash({}, {}, {hash}) {
    return axios.get(`api/substitution-proposals/hash`, { params: { hash } });
}

function updateSubstitutionProposalStatusByHash({}, data) {
    return axios.post(`api/substitution-proposals/update-status`, data);
}

function cancelSubstitution({id}) {
    return axios.delete(`api/v1/substitutions/${id}`);
}

function cancelTutorDelay({id}, data) {
    return axios.post(`api/v1/live-sessions/${id}/cancel-tutor-delay`, data);
}

function markSubstitutionProposalAsRead({id}) {
    return axios.post(`api/v1/substitution-proposals/${id}/mark-read`);
}

export const substitutionProposalsService = {
    getSubstitutionProposals,
    updateSubstitutionProposalStatus,
    getSubstitutionProposalByHash,
    updateSubstitutionProposalStatusByHash,
    cancelSubstitution,
    cancelTutorDelay,
    markSubstitutionProposalAsRead
};
